export let payInData = [
    {status:"Orders", count: "2223", percetage:"94%"},
    {status:"Sucess", count: "2223", percetage:"88%"},
    { status: "Pending", count: "2223", percetage: "44%" },
    {status:"Initiated", count: "2223", percetage:"31%"},
    {status:"Failed", count: "2223", percetage:"19%"},
    {status:"Raised", count: "2223", percetage:"99.99%"},
]

export const Scrapper_data = {
    "data": [
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649746124",
            "transaction_id": "113649746124",
            "created_date": "2025-02-14 07:09:56",
            "amount": 300.00,
            "bank_ref_number": "504507404675",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:10:01",
            "updated_on": "2025-02-14 07:21:03"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649745584",
            "transaction_id": "113649745584",
            "created_date": "2025-02-14 07:09:33",
            "amount": 300.00,
            "bank_ref_number": "504553556716",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:09:42",
            "updated_on": "2025-02-14 07:20:42"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649745513",
            "transaction_id": "113649745513",
            "created_date": "2025-02-14 07:09:30",
            "amount": 1000.00,
            "bank_ref_number": "504536423664",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:09:34",
            "updated_on": "2025-02-14 07:20:37"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649743684",
            "transaction_id": "113649743684",
            "created_date": "2025-02-14 07:08:13",
            "amount": 300.00,
            "bank_ref_number": "615853429189",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:08:22",
            "updated_on": "2025-02-14 07:19:26"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649741819",
            "transaction_id": "113649741819",
            "created_date": "2025-02-14 07:06:53",
            "amount": 300.00,
            "bank_ref_number": "504503589851",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:06:57",
            "updated_on": "2025-02-14 07:17:59"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649738053",
            "transaction_id": "113649738053",
            "created_date": "2025-02-14 07:04:24",
            "amount": 300.00,
            "bank_ref_number": "504515587870",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 129,
            "created_on": "2025-02-14 07:04:32",
            "updated_on": "2025-02-14 07:15:32"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649737992",
            "transaction_id": "113649737992",
            "created_date": "2025-02-14 07:04:23",
            "amount": 300.00,
            "bank_ref_number": "550961048455",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:04:33",
            "updated_on": "2025-02-14 07:15:37"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649735572",
            "transaction_id": "113649735572",
            "created_date": "2025-02-14 07:02:44",
            "amount": 10.00,
            "bank_ref_number": "100016016185",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 129,
            "created_on": "2025-02-14 07:03:45",
            "updated_on": "2025-02-14 07:14:46"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649734569",
            "transaction_id": "113649734569",
            "created_date": "2025-02-14 07:01:59",
            "amount": 1900.00,
            "bank_ref_number": "290091635105",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 129,
            "created_on": "2025-02-14 07:03:46",
            "updated_on": "2025-02-14 07:14:46"
        },
        {
            "scrapper_source": "ccavenue",
            "agent_name": "agent",
            "distributor_name": "Cashee",
            "order_id": "STQR-113649731181",
            "transaction_id": "113649731181",
            "created_date": "2025-02-14 06:59:41",
            "amount": 300.00,
            "bank_ref_number": "100324054803",
            "user_payment_method_id": 320,
            "process_flag": "UC",
            "error_message": "Tried so many times, marking this as unclaimed",
            "retry_count": 130,
            "created_on": "2025-02-14 07:03:47",
            "updated_on": "2025-02-14 07:14:51"
        }
    ],
    "status": "Success",
    "error": null
}